<template>
  <div>
    <CRow class="">
      <CCol md="12" lg="12" sm="12" xs="12">
        <ProccessDemoVue v-if="page == 'proccess' && $store.getters.get_company.id == 1" @changePage="changePage" @setView="setView" />
        <ProccessCarbinoVue v-if="page == 'proccess' && $store.getters.get_company.id == 5" @changePage="changePage" @setView="setView" />
        <ProccessDecorVue v-if="page == 'proccess' && $store.getters.get_company.id == 4" @changePage="changePage" @setView="setView" />
        <ProccessAqVue v-else-if="page == 'proccess' && $store.getters.get_company.id == 3" @changePage="changePage" @setView="setView" />
        <ProccessDemoVue v-if="page == 'proccess' && $store.getters.get_company.id == 6" @changePage="changePage" @setView="setView" />

        <PurchaseVue class="pt-1" v-if="page == 'purchase' && $store.getters.get_company.id == 4" @returnHome="returnHome" />
        <PurchaseVue class="pt-1" v-if="page == 'purchase' && $store.getters.get_company.id == 6" @returnHome="returnHome" />
        <PurchaseAQVue class="pt-1" v-if="page == 'purchase' && $store.getters.get_company.id == 3" @returnHome="returnHome" />
        <PurchaseCarbinoVue class="pt-1" v-if="page == 'purchase' && $store.getters.get_company.id == 5" @returnHome="returnHome" />

        <SaleVue class="pt-1" v-if="page == 'sale' && $store.getters.get_company.id == 1" @returnHome="returnHome" />
        <SaleVueAqVue class="pt-1" v-if="page == 'sale' && $store.getters.get_company.id == 3" @returnHome="returnHome" />
        <SaleCarbinoVue class="pt-1" v-if="page == 'sale' && $store.getters.get_company.id == 5" @returnHome="returnHome" />
        <SaleDecorVue class="pt-1" v-if="page == 'sale_pos' && $store.getters.get_company.id == 4" @returnHome="returnHome" />
        <SaleDecorVue class="pt-1" v-if="page == 'sale' && $store.getters.get_company.id == 6" @returnHome="returnHome" />

        <StockVue class="pt-1" v-if="page == 'stock'" @returnHome="returnHome" />
        <InputStockVue class="pt-1" v-if="page == 'input_stock' && $store.getters.get_company.id == 3" @returnHome="returnHome" />
        <MovementStockVue class="pt-1" v-if="page == 'mov_stock' && ($store.getters.get_campu.id == 11 || $store.getters.get_campu.id == 3) && $store.getters.get_company.id == 3" @returnHome="returnHome" />
        <MovementStockVue class="pt-1" v-if="page == 'mov_stock' && ($store.getters.get_company.id == 5)" @returnHome="returnHome" />
        <MovementStockDecorVue class="pt-1" v-if="page == 'mov_stock' && ($store.getters.get_company.id == 4 ||$store.getters.get_company.id == 6)" @returnHome="returnHome" />
        <ExitNoteVue class="pt-1" v-if="page == 'exit_note' " @returnHome="returnHome" />
        <ExitNoteDecorVue class="pt-1" v-if="page == 'exit_note_decor'" @returnHome="returnHome" />
        <MovementAlmacenProjectVue class="pt-1" v-if="page == 'mov_almacen_project'" @returnHome="returnHome" />
        
        <KardexVueCarbino class="pt-1" v-if="page == 'kardex' && $store.getters.get_company.id == 5"  @returnHome="returnHome" />
        <KardexVue class="pt-1" v-if="page == 'kardex' && $store.getters.get_company.id != 5" @returnHome="returnHome" />
        
        <CxcVue class="pt-1" v-if="page == 'cxc'" @returnHome="returnHome" :bead="bead"/>
        <CancelVoucher class="pt-1" v-if="page == 'cancel_voucher'" @returnHome="returnHome" />
        <ProductionVue class="pt-1" v-if="page == 'production' && $store.getters.get_company.id == 3" @returnHome="returnHome" />
        <ListProducts class="pt-1" v-if="page == 'list_products'" @returnHome="returnHome" />
      </CCol>
    </CRow>
  </div>
</template>

<script>

import ProccessDemoVue from '../../components/proccess/demo/Home.vue';
import PurchaseVue from '../../components/proccess/demo/purchase/page/Purchase.vue';
import PurchaseAQVue from '../../components/proccess/aq/purchase/page/Purchase.vue';
import PurchaseCarbinoVue from '../../components/proccess/carbino/purchase.vue';

import SaleVue from '../../components/proccess/demo/sale/page/Sale.vue';
import StockVue from '../../components/proccess/demo/stock/page/Stock.vue';
import InputStockVue from '../../components/proccess/aq/InputStock/page/InputStock.vue';

import KardexVue from '../../components/proccess/demo/kardex/page/Kardex.vue';
import KardexVueCarbino from '../../components/proccess/carbino/kardex.vue';
import MovementStockVue from '../../components/proccess/aq/movementstock/page/MovementStock.vue';
import MovementStockDecorVue from '../../components/proccess/demo/movementstock/page/MovementStock.vue';
import MovementAlmacenProjectVue from '../../components/proccess/demo/MovementAlmacenProject/MovementAlmacenProject.vue';
import CxcVue from '../../components/proccess/demo/cxcs/page/Cxv.vue';
import CancelVoucher from '../../components/proccess/demo/CancelVocuher/Cancel.vue';
import ExitNoteVue from '../../components/proccess/aq/exitnote/page/ExitNote.vue';
import ExitNoteDecorVue from '../../components/proccess/decor/exitnote/page/ExitNote.vue';
/**  */
import ProccessAqVue from '../../components/proccess/aq/Home.vue';
import SaleVueAqVue from '../../components/proccess/aq/sale/page/Sale.vue';
import ProductionVue from '../../components/proccess/aq/production/page/Production.vue';
import ListProducts from '../../components/proccess/aq/ListProducts/ListProducst.vue';
/*  */
import ProccessDecorVue from '../../components/proccess/decor/Home.vue';
import SaleDecorVue from '../../components/proccess/decor/sale/page/Sale.vue';

/*Carbino*/
import ProccessCarbinoVue from '../../components/proccess/carbino/Home.vue';
import SaleCarbinoVue from '../../components/proccess/carbino/sale/page/Sale.vue';



import { mapActions } from "vuex";
export default {
  components: {
    PurchaseVue,
    PurchaseAQVue,
    SaleVue,
    SaleDecorVue,
    SaleCarbinoVue,
    ProccessDemoVue,
    StockVue,
    InputStockVue,
    KardexVue,
    MovementStockVue,
    MovementStockDecorVue,
    MovementAlmacenProjectVue,
    CxcVue,
    CancelVoucher,
    ProccessAqVue,
    ProccessDecorVue,
    ProccessCarbinoVue,
    SaleVueAqVue,
    ExitNoteVue,
    ExitNoteDecorVue,
    ProductionVue,
    ListProducts,
    PurchaseCarbinoVue,
    KardexVueCarbino
  },
  data() {
    return {
      page: 'proccess',
      bead: {},
    }
  },
  created() {
      this.mtdDataBead();
  },
  methods: {
    ...mapActions(["get", "post"]),

    changePage(page) {
      this.page = page;
      this.$emit("mtdViewFooter", false, 'proccess');
    },
    returnHome() {
      this.page = 'proccess';
      this.$emit("mtdViewFooter", true, 'proccess');
    },
    mtdBack: function () {
      this.page = 'proccess';
      this.$emit("mtdViewFooter", true, 'proccess');
      // this.$emit('setView', 'home')
    },
    setView: function () {
      this.$emit('setView', 'home')
    },

    mtdDataBead() {
        this.get({
            url: this.$store.getters.get__url +
                "/cxc/listBeads/" +
                this.$store.getters.get_campu.id + "/" +
                this.$store.getters.get_company.id,
            token: this.$store.getters.get__token,
        })
        .then((response) => {
            this.bead = response.data.bead;
        })
        .catch((errors) => {
            console.log(errors);
        });
    },


  }
};
</script>
